import { Eye, Target } from "lucide-react";
import { useSeo } from "@/lib/useSeo";
import { useApi } from "@/lib/api";
import { PageHero, Reveal, SectionHeading, Spinner } from "@/components/site/kit";
import { DynIcon } from "@/components/site/DynIcon";
import { CtaBanner, StatsBar, WhyUs } from "@/components/site/Sections";

export default function About() {
  useSeo({ title: "About Us", description: "Own Brand Technologies is a Faridabad-based software company building custom software, apps and automation for Indian businesses." });
  const { data: a } = useApi("/content/about");
  const { data: h } = useApi("/content/homepage");
  if (!a) return <Spinner className="min-h-[60vh]" />;
  return (
    <>
      <PageHero badge="About us" title={a.headline} highlight={a.highlight} subtitle={a.intro} />
      <section className="section bg-page">
        <div className="container-x grid gap-12 lg:grid-cols-[1.2fr_0.8fr]">
          <Reveal>
            <h2 className="text-3xl font-extrabold">Our <span className="text-ocean">story</span></h2>
            <p className="mt-6 text-base leading-relaxed text-body md:text-lg" data-testid="about-story">{a.story}</p>
          </Reveal>
          <div className="space-y-5">
            {[{ icon: Target, t: "Mission", d: a.mission }, { icon: Eye, t: "Vision", d: a.vision }].map(({ icon: I, t, d }, i) => (
              <Reveal key={t} delay={i * 0.1}>
                <div className="card-base p-7" data-testid={`about-${t.toLowerCase()}`}>
                  <I className="h-7 w-7 text-sky" />
                  <h3 className="mt-4 text-lg font-bold">Our {t}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-body">{d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      {h && <section className="bg-white py-16"><div className="container-x"><StatsBar stats={h.stats} /></div></section>}
      <section className="section bg-page">
        <div className="container-x">
          <SectionHeading badge="Our values" title="What we" highlight="stand for" center />
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {(a.values || []).map((v, i) => (
              <Reveal key={v.title} delay={i * 0.08}>
                <div className="card-base card-hover h-full p-7">
                  <span className="grid h-12 w-12 place-items-center rounded-xl bg-[#EEF6FC] text-ocean"><DynIcon name={v.icon} className="h-6 w-6" /></span>
                  <h3 className="mt-5 text-lg font-bold">{v.title}</h3>
                  <p className="mt-2 text-sm text-body">{v.description}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      {h && <WhyUs why={h.why_us} />}
      <section className="section bg-white"><div className="container-x"><CtaBanner title="Let's build something great together" subtitle="Book a free consultation with our team today." button="Get a Free Quote" /></div></section>
    </>
  );
}
